import React from 'react';
import { connect } from 'react-redux';
import { AppState, IPageState } from './../appredux';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField, FormControl } from '@material-ui/core';
import ResponsiveImgMaterialUi from 'responsive-img-material-ui';



interface DialogProps extends WithStyles<typeof styles> {
    page: IPageState,
    open: boolean,
    closeDialog: () => void,
}

interface DialogState {
    haslo: string,
    pokazKod: boolean,
    kod: string,
    
}

class DialogUkryjPracownika extends React.Component<DialogProps, DialogState>  {

    constructor(props: DialogProps) {
        super(props, {});
        this.state = {
            haslo: "",
            pokazKod: false,
            kod: ""
        }
    }

    componentDidUpdate(prevProps: DialogProps) {
        if (this.props.open !== prevProps.open) {
            let storageKod = localStorage.getItem("kod");
            let kod = ""
            if(storageKod) kod = storageKod
            this.setState({
                haslo: "",
                pokazKod: false,
                kod: kod
            })
        }
    }

    zmienHaslo = async (event: React.ChangeEvent<{ name?: string; value: string }>) => {
            this.setState({
                ...this.state, haslo: event.target.value, 
            }); 
    }
    zmienKod = async (event: React.ChangeEvent<{ name?: string; value: string }>) => {
            this.setState({
                ...this.state, kod: event.target.value, 
            }); 
    }
    next = () => {
        if(this.state.haslo === "1029") {
            this.setState({pokazKod: true})
            let field = document.getElementById("textField2")  ////
            if(field) field.focus()                            //// 
        } else {
            this.props.closeDialog()
        }   
    }
    zapiszKod = () => {
        localStorage.setItem("kod", this.state.kod);
        this.props.closeDialog()
        window.location.reload()
    }


    render() {
        const classes = this.props.classes;

        let pokazKod = this.state.pokazKod
       
        return (
            <>
                <Dialog
                    maxWidth="xs"
                    open={this.props.open}
                    onEscapeKeyDown={this.props.closeDialog}
                    onBackdropClick={this.props.closeDialog}
                    fullWidth
                >
                    <DialogTitle disableTypography style={{padding: "16px 24px 0px 24px"}}>
                        <Typography gutterBottom variant="h6" component="h2" color='primary'
                            className={`${classes.headline}`}><b style={{ }}>{!pokazKod ? "wpisz hasło" : "wpisz identyfikator"}</b>
                        </Typography>
                        <hr style={{ marginTop: "10px", borderBottom: "0px" }} />
                    </DialogTitle>
                    <DialogContent>
                       {!pokazKod ? 
                        <FormControl variant="outlined" fullWidth className={classes.formControl}>
                            <label className={`${classes.label} ${classes.primary}`} style={{ float: 'left', width: '21%'}}>
                            {"Hasło"}</label>
                            <TextField
                                onChange={this.zmienHaslo}
                                
                                className={classes.floatLeft}
                                style={{ width: '70%', float: 'right', marginBottom: '25px' }}
                                variant="outlined"
                                InputProps={{ classes: { input: `${classes.primary} ${classes.input} ${this.state.haslo.length > 0 ? classes.backgroundGreen : classes.backgroundWhite}` } }}
                                value={this.state.haslo}
                                type='number'
                                autoFocus
                            />
                        </FormControl>
                        : 
                        <FormControl variant="outlined" fullWidth className={classes.formControl}>
                        <label className={`${classes.label} ${classes.primary}`} style={{ float: 'left', width: '21%'}}>
                        {"Identyfikator"}</label>
                        <TextField id="textField2"
                            onChange={this.zmienKod}
                            className={classes.floatLeft}
                            style={{ width: '70%', float: 'right', marginBottom: '25px' }}
                            variant="outlined"
                            InputProps={{ classes: { input: `${classes.primary} ${classes.input} ${this.state.kod.length > 0 ? classes.backgroundGreen : classes.backgroundWhite}` } }}
                            value={this.state.kod}
                            type='number'
                            autoFocus
                        />
                    </FormControl>}
                        
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" color="primary" size="small" className={classes.button}
                            onClick={this.props.closeDialog}>
                            <b>wróć</b>
                        </Button>
                        <Button variant="contained" color="primary" size="small" className={classes.button}
                            onClick={() => {!pokazKod ? this.next() : this.zapiszKod()}}>
                            <b>OK</b>
                        </Button>
                    </DialogActions>
                </Dialog>
            </>

        );
    }
}

const styles = (theme: Theme) => ({
    primary: {
        color: theme.palette.primary.main
      },
      secondary: {
        color: theme.palette.secondary.main
      },
      error: {
          color: "rgb(244, 67, 54)"
      },
      paddingBottom0: {
        paddingBottom: 0
      },
      paddingLeft: {
        paddingLeft: "20px"
      },
      headline: {
        lineHeight: "20px",
      },
      dialogContentText: {
        color: theme.palette.text.secondary,
        whiteSpace: "pre" as "pre",
        minHeight: "12px",
        marginBottom: '12px'
      },
      button: {
        textTransform: "none" as "none"
    },

    backgroundWhite: {
        backgroundColor: "#ffffff"
    },
    backgroundGreen: {
        backgroundColor: "rgb(232, 245, 233)"
    },
    floatLeft: {
        float: "left" as "left"
    },
    black: {
        color: "rgb(0, 0, 0)"
    },
    input: {
        padding: "8px 8px",
        //padding: "8px 14px",
        fontWeight: 'normal' as 'normal',
        textAlign: 'left' as 'left'
    },
    formControl: {
        display: "inline-block",
    },
    label: {
        fontSize: "12px",
        fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
        lineHeight: "20px",
        fontWeight: theme.typography.body2.fontWeight,
        padding: "7px 0 4px"
    },
});

const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
});

export default connect(mapStateToProps)(withStyles(styles)(DialogUkryjPracownika));

